import axios from "axios";
import Cookies from "js-cookie";
import { Constants } from "../../constants";

const state = {
  user: {
    id: null,
    companyName: null,
    username: null,
    phoneNo: null,
    logo: null,
    lastLogin: null,
    role: null,
  },
  token: null,
  authStatus: false,
};

const getters = {
  user(state) {
    return state.user;
  },

  token(state) {
    return state.token;
  },

  isAuthenticated(state) {
    return state.authStatus;
  },
};

const mutations = {
  setUser(state) {
    state.user = JSON.parse(Cookies.get(Constants.LOGIN_USER));
  },

  setToken(state) {
    state.token = Cookies.get(Constants.API_TOKEN);
  },

  setAuthStatus(state) {
    state.authStatus = !!state.token;
  },
};

const actions = {
  setUser({ commit }) {
    commit("setUser");
  },

  setToken({ commit }) {
    commit("setToken");
  },

  setAuthStatus({ commit }) {
    commit("setAuthStatus");
  },

  async userAuth({ commit }, inputs) {
    const url =  process.env.VUE_APP_API_URL + "/auth/signin";

    return await axios.post(url, inputs);
  },

  async userPasswordUpdate({ rootState }, inputs) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/auth/password-update`, inputs, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
